import React from 'react';
import { Input, Button } from 'antd';
import { SvgIconText } from 'freesia-ui';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

export default class TableColumnsEditor extends PropertyEditor {

    state = {
        values: []
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e, index, key) {
        let values = this.state.values;
        values[index][key] = e.target.value;
        this.props.source.value = [...values];
        this.setState({ values: values });
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({ values: this.props.source.value });
    }

    componentWillMount() {
        super.componentWillMount();
        this.setState({ values: this.props.source.value });
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);
        this.setState({ values: nextProps.source.value });
    }


    add() {
        let values = this.state.values;
        values.push({});
        this.props.source.value = [...values];
        this.setState({
            values
        })
    }

    deleteItem(index) {
        let values = this.state.values;
        values.splice(index, 1);
        this.props.source.value = [...values];
        this.setState({
            values
        })
    }

    render() {
        let values = this.state.values;
        return (
            <div>
                {values.map((v, index) => {
                    return (
                        <div key={index} className="layout-h" style={{ marginTop: 3 }}>
                            <Input className="fill" value={v.name} style={{ flex: '.8 .8' }} onChange={e => this.onChange(e, index, "name")} placeholder={"列名"} />
                            <Input className="sp-left fill" value={v.expression} style={{ flex: '1.2 1.2' }} onChange={e => this.onChange(e, index, "expression")} placeholder={"求值表达式"} />
                            <Button className="sp-left" style={{ padding: 5 }} title={"移除"} onClick={e => this.deleteItem(index)} >
                                <SvgIconText type="#anticon-delete18" />
                            </Button>
                        </div>
                    )
                })}
                <Button onClick={this.add.bind(this)}>添加</Button>
            </div>
        );
    }
}

PropertyGridUtils.register("tableColumns", (source, propertyGrid) => <TableColumnsEditor source={source} propertyGrid={propertyGrid} />);